import React from 'react';
import {useCategories, useInfiniteEvents} from '../../api/hooks';
import Loader from '../pages/Loader';
import Error from '../pages/Error';
import {Translate} from '../../config/TranslationProvider';
import EventsListing from './EventsListing';
import { formatISO, startOfToday } from 'date-fns';

const ChildEvents = ({parentId, tagAsChildEvents}) => {
    // Build events filter
    const childEventsFilter = {'end_date_from': formatISO(startOfToday())};
    if (tagAsChildEvents) {
        // If tagAsChildEvents is set, search for events with the provided tag
        childEventsFilter['tags_title'] = [tagAsChildEvents.title];
    } else {
        // Else just search for events that have the current event id set as parent event
        childEventsFilter['parent_event'] = parentId;
    }

    const {
        data: eventGroups,
        isLoading: eventsLoading,
        error: eventsError,
        fetchMore,
        canFetchMore,
        isFetchingMore
    } = useInfiniteEvents(childEventsFilter);
    const {data: categories, isLoading: categoriesLoading, error: categoriesError} = useCategories();

    if (eventsLoading || categoriesLoading) {
        return <Loader />;
    }

    if (categoriesError || eventsError) {
        return <Error errors={[categoriesError && categoriesError, eventsError && eventsError]} />;
    }

    return (
        <div className="atbd_content_module">
            <div className="atbd_content_module__tittle_area">
                <div className="atbd_area_title">
                    <h2 className="h4"><span className="la la-group" />&nbsp;
                        <Translate value="events" />
                    </h2>
                </div>
            </div>
            <div className="atbdb_content_module_contents">
                <EventsListing
                    type="grid6"
                    eventGroups={eventGroups}
                    fetchMore={fetchMore}
                    canFetchMore={canFetchMore}
                    isFetchingMore={isFetchingMore}
                    categories={categories}
                />
            </div>
        </div>
    );
};

export default ChildEvents;
